var defaultTypographyProps = {
    variant: 'body1',
};

export { defaultTypographyProps };
//# sourceMappingURL=TypographyProps.js.map
